"use strict";

module.exports = require("../dnd/dnd");



//////////////////
// WEBPACK FOOTER
// ./~/fine-uploader/lib/dnd.js
// module id = wKfx
// module chunks = 1